import { render, staticRenderFns } from "./StudentPoint.vue?vue&type=template&id=d98dafb2&"
import script from "./StudentPoint.vue?vue&type=script&lang=js&"
export * from "./StudentPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports